<template>
    <div class="mt-2">
        <v-row no-gutters class="pb-5">
            <v-col>
                {{ title }}
            </v-col>
            <v-col class="d-flex align-center justify-end">
                <v-btn-add-icon size="x-small" @click="tagDialog = true"> </v-btn-add-icon>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-list>
                    <v-list-item
                        :class="
                            !$vuetify.display.mobile
                                ? 'mb-2 oss-list-item rounded-lg'
                                : 'mb-2 px-2 oss-list-item rounded-lg'
                        "
                        v-for="(thirdPartyCompanyTag, index) in thirdPartyCompanyTags"
                        :key="index"
                    >
                        <template #prepend>
                            <v-icon color="secondary"> $label_outline </v-icon>
                        </template>

                        <v-list-item-title>{{ tagTitle(thirdPartyCompanyTag) }}</v-list-item-title>

                        <template v-slot:append>
                            <v-btn-trash @click="deleteTagRule(thirdPartyCompanyTag)" />
                        </template>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
        <FreeTag
            v-model:inDialog="tagDialog"
            :companyTags="allCompanyTags"
            :company="selectedCompany"
            :createIfMissing="true"
            @onTagsChanged="onTagsChanged"
            v-if="tagDialog"
        >
        </FreeTag>
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import THIRDPARTYCOMPANY_TAGS_QUERY from "../../graphql/tag/ThirdPartyCompanyTags.gql";
import CREATE_THIRDPARTYCOMPANY_TAG_RULE from "../../graphql/tag/CreateThirdPartyCompanyTagRule.gql";
import DELETE_THIRDPARTYCOMPANY_TAG_RULE from "../../graphql/tag/DeleteThirdPartyCompanyTag.gql";

import FreeTag from "./FreeTag.vue";
import { ComponentBase } from "../ComponentBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        FreeTag,
    },
})
export class ThirdPartyCompanyTag extends ComponentBase {
    @Prop({ default: null }) companyId;
    @Prop({ default: null }) thirdPartyCompanyId;
    @Prop({ default: null }) actions;

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get activateTagguing() {
        return true;
    }

    tagDialog: boolean = false;

    get title() {
        if (this.thirdPartyCompanyTags.length) {
            return "";
        }
        return "Ajouter une étiquette";
    }

    @Apollo({
        query() {
            return THIRDPARTYCOMPANY_TAGS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                thirdPartyCompanyIds: [this.thirdPartyCompanyId],
            };
        },
        skip() {
            return !this.thirdPartyCompanyId || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data && data.thirdPartyCompanyTags) {
                this.thirdPartyCompanyTags = data.thirdPartyCompanyTags;
            } else {
                this.thirdPartyCompanyTags = [];
            }
        },
    })
    thirdPartyCompanyTags: any[] = [];

    tagTitle(thirdPartyCompanyTag) {
        let title = "XXX";
        if (thirdPartyCompanyTag.tag) {
            title = thirdPartyCompanyTag.tag.name;
            if (thirdPartyCompanyTag.tag.primaryLog) {
                title += " - journal " + this.$t("." + thirdPartyCompanyTag.tag.primaryLog);
            }
            if (thirdPartyCompanyTag.tag.partitionTag) {
                title += " - partition " + thirdPartyCompanyTag.tag.partitionTag.name;
            }
        }
        return title;
    }

    async onTagsChanged(data) {
        if (data.tags?.length === 1) {
            if (!this.thirdPartyCompanyId) {
                debugger;
                return;
            }
            const tagId = data.tags[0].id;
            if (tagId && this.thirdPartyCompanyId && this.companyId) {
                await this.$apollo
                    .mutate({
                        mutation: CREATE_THIRDPARTYCOMPANY_TAG_RULE,
                        variables: {
                            companyId: this.companyId,
                            thirdPartyCompanyId: this.thirdPartyCompanyId,
                            tagId,
                        },
                    })
                    .catch((err) => {
                        debugger;
                    });
                this.refresh();
            }
        }
        this.tagDialog = false;
    }

    async deleteTagRule(thirdPartyCompanyTag) {
        await this.$apollo
            .mutate({
                mutation: DELETE_THIRDPARTYCOMPANY_TAG_RULE,
                variables: {
                    id: thirdPartyCompanyTag.id,
                },
            })
            .catch((err) => {
                debugger;
            });

        this.refresh();
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.thirdPartyCompanyTags) {
            this.$apollo.queries.thirdPartyCompanyTags.refetch();
        } else {
            debugger;
        }
    }
}

export default toNative(ThirdPartyCompanyTag);
</script>
